import React from 'react'
import styled from '@emotion/styled'
import { BNDLogo } from '../svgs/BNDLogo'
import { Link } from '@jelly/ui'

const HOMEPAGE = '/'

const BndLogoWrapper = styled(Link)`
	display: inline-block;
	height: 45px;
	padding-left: 0.5rem;
	width: 145px;

	${({ theme }) => theme.MQ.S} {
		height: 50px;
		width: 162px;
	}
`

export function HeaderLogoBnd() {
	return (
		<BndLogoWrapper href={HOMEPAGE} aria-label="businessnewsdaily.com Logo">
			<BNDLogo />
		</BndLogoWrapper>
	)
}
